import React from "react";
import { useParams } from "react-router-dom";
import EmailView from "./EmailView";
import PendingList from "./PendingList";

function EmailPendingTab() {
  const { tab, type, id } = useParams();

  return (
    <div>
      {type && type == "table" && !id && <PendingList />}
      {type && type == "view" && id && <EmailView email_id={id} />}
      {/* {type && type == "add" && !id && <CustomerAdd />}
  {type && type == "edit" && id && <CustomerEdit customer_id={id} />}*/}
    </div>
  );
}

export default EmailPendingTab;
